import { gql } from "@apollo/client";

export const PROCESSES = gql`
  query Processes(
    $where: ProcessWhereInput
    $isIn: JSONObject
    $take: Int
    $skip: Int
    $like: ProcessWhereInput
    $orderBy: [JSONObject]
  ) {
    processes(
      where: $where
      take: $take
      skip: $skip
      like: $like
      orderBy: $orderBy
      isIn: $isIn
    ) {
      data {
        id
        name
        description
        type
        theme
        processStatuses {
          id
          name
          tag
          template
          progress
          order
          color
          background
          moveToNext
          possibleStatuses {
            id
            nextStatus
            conditions {
              id
              operation
              rightOperand
              leftOperand
            }
          }
        }
      }
      count
    }
  }
`;

const PROCESS_SCREEN_FIELDS = `
  currentPublishedVersion {
    id
    versionNumber
    status
    previewImageBase64
    htmlContent
    styleContent
    bindingManifest {
      id
      slots
      report
    }
    translationTable {
      id
      entries
    }
    states {
      id
      name
      order
      htmlContent
      conditions
      bindingManifest {
        id
        slots
        report
      }
    }
  }
  versions {
    id
    versionNumber
    status
    updatedDate
    htmlContent
    styleContent
    bindingManifest {
      id
      slots
      report
    }
    states {
      id
      name
      order
      htmlContent
      conditions
      bindingManifest {
        id
        slots
        report
      }
    }
  }
`;

export const PROCESS = gql`
  query Process($where: ProcessWhereInput) {
    process(where: $where) {
      id
      name
      type
      description
      theme
      additionalInfo
      ownedBy {
        id
      }
      insurancePlans {
        id
      }
      config {
        id
        type
        value
      }
      processStatuses {
        id
        name
        tag
        template
        progress
        order
        color
        background
        moveToNext
        nodeType
        config
        formDefinition
        position
        entryConnectors
        outputConnectors
        dataBindings
        possibleStatuses {
          id
          order
          nextStatus
          kind
          event
          delaySeconds
          conditions {
            id
            operation
            rightOperand
            leftOperand
          }
        }
        actions {
          id
          type
          args
          conditions {
            id
            operation
            rightOperand
            leftOperand
          }
        }
        screens {
          id
          ${PROCESS_SCREEN_FIELDS}
        }
      }
      skills {
        id
        type
        value
      }
    }
  }
`;

export const PROCESS_DRAFT = gql`
  query ProcessDraft($where: ProcessDraftWhereInput!) {
    processDraft(where: $where) {
      id
      graph
      revision
      updatedDate
      updatedBy
      process {
        id
      }
      screens {
        id
        draftStatusId
        ${PROCESS_SCREEN_FIELDS}
      }
    }
  }
`;

export const PROCESS_DRAFT_ID = gql`
  query ProcessDraftId($where: ProcessDraftWhereInput!) {
    processDraft(where: $where) {
      id
      revision
    }
  }
`;

export const PROCESS_SESSION_REPLAY = gql`
  query ProcessSessionReplay($where: ProcessWhereInput) {
    process(where: $where) {
      id
      additionalInfo
      processStatuses {
        id
        config
      }
    }
  }
`;

export const PROCESS_OPTIONS = gql`
  query ProcessOptions($where: ProcessWhereInput) {
    processes(where: $where) {
      data {
        id
        name
      }
    }
  }
`;

export const PROCESS_IDS = gql`
  query ProcessIds($isIn: JSONObject) {
    processes(isIn: $isIn) {
      data {
        id
      }
    }
  }
`;

export const CANVAS_MESSAGE_FIELDS = `
  id
  role
  text
  refs
  status
  error
  proposal
  proposalStatus
  authorId
  createdDate
`;

export const CANVAS_CONVERSATION = gql`
  query CanvasConversation($where: ProcessDraftWhereInput!) {
    canvasConversation(where: $where) {
      id
      createdDate
      messages {
        ${CANVAS_MESSAGE_FIELDS}
      }
    }
  }
`;

export const CANVAS_MESSAGE = gql`
  query CanvasMessage($where: CanvasMessageWhereInput!) {
    canvasMessage(where: $where) {
      ${CANVAS_MESSAGE_FIELDS}
    }
  }
`;

const processes = {
  PROCESSES,
  PROCESS,
  PROCESS_DRAFT,
  PROCESS_DRAFT_ID,
  PROCESS_SESSION_REPLAY,
  PROCESS_IDS,
  CANVAS_CONVERSATION,
  CANVAS_MESSAGE,
};

export default processes;
